<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: null,
        required: true,
      },
      type: {
        type: String,
        default: 'input',
      },
      trackBy: {
        type: String,
        default: 'id',
      },
      keyOfColumn: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        default: () => [],
      },
      checkboxId: {
        type: Number,
        default: 0,
      },
      placeholder: {
        type: String,
        default: '',
      },
      size: {
        type: String,
        default: 'md',
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      notEmptyOption: {
        type: Boolean,
        default: false,
      },
      maxHeight: {
        type: Number,
        default: 200,
      },
    },
    data() {
      return {
        model: this.value,
      }
    },
    computed: {
      updateOptions() {
        if (this.notEmptyOption) {
          return this.options;
        } else {
          let newOptions = [];
          newOptions.push({
            fileColumn: '',
            label: 'N/A',
          });
          newOptions = newOptions.concat(this.options);
          return newOptions;
        }
      },
    },
    watch: {
      model (val) {
        this.$emit('change', val)
      },
      value (newVal) {
        this.value = newVal;
      },
    },
    methods: {
      changeCheck(value) {
        this.value.isChecked = value;
        this.$emit('changeColumn', this.value, this.keyOfColumn);
      },
      changeSlect(option) {
        this.value.selectValue = option;
        this.$emit("changeColumn", this.value, this.keyOfColumn);
      }
    }
  }
</script>

<template>
  <div class="group-upload-option">
    <template v-if="type === 'input'">
      <input
        v-model="value.inputValue" 
        :disabled="disabled" 
        class="form-control"
        aria-label="Text input with checkbox" 
        placeholder="Model"/>
    </template>
    <template v-if="type === 'dropdown'">
      <Multiselect
        v-model="value.selectValue"
        v-bind="$attrs"
        :track-by="trackBy"
        label="label"
        :multiple="false"
        :class="{
          'scrollable': updateOptions.length > 7,
        }"
        :options="updateOptions"
        :loading="isLoading"
        :internal-search="true"
        :show-labels="false"
        :disabled="disabled || value.isChecked"
        :placeholder="placeholder"
        :allow-empty="false"
        :max-height="maxHeight"
        class="custom-multiselect"
        @select="changeSlect"
      />
    </template>
    <div>
      <FabricCheckbox
        :id="`checkbox-${checkboxId}`"
        v-model="value.isChecked"
        :disabled="disabled || (value.isMandatory && !value.selectValue)"
        no-label
        @update="changeCheck"
      />
    </div>
  </div>
</template>
